<script>
export default {
  data() {
    return {
      isExpanded: false
    }
  },

  computed: {
    buttonText() {
      if (this.isExpanded) return 'ปิดแสดงช่องทางชำระเงิน'

      return 'แสดงช่องทางชำระเงิน'
    },

    buttonIcon() {
      if (this.isExpanded) return 'el-icon-arrow-up'

      return 'el-icon-arrow-down'
    }
  },

  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded
    },

    handleToggleButtonClick() {
      this.toggle()
    }
  },

  render() {
    return (
      <div>
        <el-row type="flex" gutter={16} align="bottom">
          <el-col span={null} style={{ flex: '1' }}>
            {this.$slots.header}
          </el-col>
          {this.$slots.actions &&
            this.$slots.actions
              .filter(vnode => vnode.tag)
              .map(vnode => <el-col span={null}>{vnode}</el-col>)}
          <el-col span={null}>
            <el-button size="mini" onClick={this.handleToggleButtonClick}>
              {this.buttonText}
              <i class={[this.buttonIcon, 'el-icon--right']} />
            </el-button>
          </el-col>
        </el-row>
        <el-collapse-transition>
          {this.isExpanded && (
            <div>
              <div style={{ padding: '1em 0' }}>{this.$slots.default}</div>
            </div>
          )}
        </el-collapse-transition>
      </div>
    )
  }
}
</script>
